import { registerApplication, start } from "single-spa";
import {
	constructApplications,
	constructRoutes,
	constructLayoutEngine,
} from "single-spa-layout";
import tabSession from "@foundant/tab-session";
import { inMemSession } from "@foundant/auth-session";

const rootLayout = document.querySelector("#single-spa-layout");

const loadingFns = {
	"@ft/header": () => {
		// @ts-ignore
		return import("header/app");
	},
	"@ft/landing": () => {
		// @ts-ignore
		return import("landing/app");
	},
	"@ft/foundant-user": () => {
		// @ts-ignore
		return import("foundant_user/app");
	},
	"@ft/iam": () => {
		// @ts-ignore
		return import("iam/app");
	},
	"@ft/data-import": () => {
		// @ts-ignore
		return import("data_import/app");
	},
	"@ft/site-management": () => {
		// @ts-ignore
		return import("site_management/app");
	},
	"@ft/ft-admin": () => {
		// @ts-ignore
		return import("ft_admin/app");
	},
	"@ft/accounting": () => {
		// @ts-ignore
		return import("accounting/app");
	},
	"@ft/taxonomy": () => {
		// @ts-ignore
		return import("taxonomy/app");
	},
	"@ft/crm": () => {
		// @ts-ignore
		return import("crm/app");
	},
	"@ft/fundraising": () => {
		// @ts-ignore
		return import("fundraising/app");
	},
	"@ft/correspondence": () => {
		// @ts-ignore
		return import("correspondence/app");
	},
};

const data = {
	loaders: {
		mountLoader: `<div class="ft-loading"><div id="loading"></div></div>`,
	},
};

const routes = constructRoutes(rootLayout, data);
let applications = constructApplications({
	routes,
	loadApp: function ({ name }) {
		return loadingFns[name]();
	},
});
constructLayoutEngine({ routes, applications });

applications.forEach((cfg) => {
	registerApplication({
		name: cfg.name,
		activeWhen: cfg.activeWhen,
		app: cfg.app,
		customProps: {
			parentSession: inMemSession,
		},
	});
});

window.sessionStorage.setItem("e", tabSession.getEnvParam());
start({ urlRerouteOnly: true });
